import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import batSrc from './assets/bat.gif'
import random from 'lodash/random'
import './styles.scss'

const Bat = ({ batNumber }) => {
  const defaultPosition = { top: -random(88, 600) }

  const [position, setPosition] = useState(defaultPosition)

  useEffect(() => {
    const top = random(0, 50)
    const rotate = random(-5, 45)

    setPosition({
      top: `${top}vh`,
      transform: `rotate(${rotate}deg)`
    })

    const interval = setInterval(() => {
      const top = random(0, 50)
      const rotate = random(-5, 45)

      setPosition({
        top: `${top}vh`,
        transform: `rotate(${rotate}deg)`
      })
    }, 10000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className={`bat-container absolute bat-${batNumber}`}>
      <div className="absolute bat-scale">
        <img src={batSrc} className="bat absolute" style={{ ...position }} />
      </div>
    </div>
  )
}

Bat.propTypes = {
  batNumber: PropTypes.number
}

export default Bat
